import { Action } from 'common/interfaces/root';
import { asinRecommendationActionTypes as TYPES } from '../actions/action-types';

const initialState: AsinRecommendationModule.State.VariationsState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AsinRecommendationModule.State.VariationsState = initialState,
  { type, payload }: Action
): AsinRecommendationModule.State.VariationsState => {
  switch (type) {
    case TYPES.VARIATIONS.GET_VARIATIONS:
      return { ...state, loading: true };
    case TYPES.VARIATIONS.GET_VARIATIONS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.VARIATIONS.GET_VARIATIONS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
